import { LOCATION_CHANGE, RouterAction } from "connected-react-router"
import { Reducer } from "redux"
import { WorkerGroupType, AuthUserType } from "../../Actions/Types"
import {
    APIAppWorkerGroup,
    getAppWorkerGroupId
} from "../../Models/API/AppWorkerGroup"
import { APIWorkerGroup, getWorkerGroupId } from "../../Models/API/WorkerGroup"
import {
    getInitialData,
    markAllPagesOfAllEntriesAsStale,
    RemoteData,
    setPage
} from "../../Models/Client/RemoteData"
import { SortExpression } from "../../Models/Client/SortExpression"
import { AuthAction } from "../Auth"

export interface WorkerGroupState {
    org: {
        [orgUsername: string]:
            | RemoteData<APIWorkerGroup, SortExpression<APIWorkerGroup>, string>
            | undefined
    }
    app: {
        [appID: string]:
            | RemoteData<
                  APIAppWorkerGroup,
                  SortExpression<APIAppWorkerGroup>,
                  string
              >
            | undefined
    }
}

interface WorkerSetWorkerGroupListAction {
    type: WorkerGroupType.setList
    meta: {
        total: number
        page: number
        orgUsername: string
        sort: SortExpression<APIWorkerGroup>
    }
    payload: APIWorkerGroup[]
}

interface WorkerSetAppWorkerGroupListAction {
    type: WorkerGroupType.setAppWorkerGroupList
    meta: {
        total: number
        page: number
        appID: string
        sort: SortExpression<APIAppWorkerGroup>
    }
    payload: APIAppWorkerGroup[]
}

export type WorkerGroupAction =
    | WorkerSetWorkerGroupListAction
    | WorkerSetAppWorkerGroupListAction

const initialState: WorkerGroupState = {
    org: {},
    app: {}
}

export const WorkerGroupReducer: Reducer<
    WorkerGroupState,
    WorkerGroupAction | AuthAction | RouterAction
> = (state = initialState, action): WorkerGroupState => {
    switch (action.type) {
        case LOCATION_CHANGE:
            return {
                ...state,
                org: markAllPagesOfAllEntriesAsStale(state.org),
                app: markAllPagesOfAllEntriesAsStale(state.app)
            }
        case WorkerGroupType.setList:
            return {
                ...state,
                org: {
                    [action.meta.orgUsername]: setPage(
                        state.org[action.meta.orgUsername] ?? getInitialData(),
                        action.meta.sort,
                        action.payload,
                        getWorkerGroupId,
                        action.meta.page,
                        action.meta.total
                    )
                }
            }
        case WorkerGroupType.setAppWorkerGroupList:
            return {
                ...state,
                app: {
                    [action.meta.appID]: setPage(
                        state.app[action.meta.appID] ?? getInitialData(),
                        action.meta.sort,
                        action.payload,
                        getAppWorkerGroupId,
                        action.meta.page,
                        action.meta.total
                    )
                }
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
